import {
  SocialButton
} from "../chunk-TY4DM4QD.mjs";
import "../chunk-7CU25RIV.mjs";

// src/social-buttons/social-button-linkedin.tsx
import * as React from "react";
import { systemForwardRef } from "@stepstone-genesis/system";
import { SocialLinkedinColouredIcon } from "@stepstone-genesis/icons";
var SocialLinkedInButton = systemForwardRef(function SocialLinkedInButton2({ children, ...props }, ref) {
  var _a;
  const defaultLabel = "Log in with LinkedIn";
  return /* @__PURE__ */ React.createElement(
    SocialButton,
    {
      ref,
      element: "SOCIAL_LINKEDIN_BUTTON",
      ...props,
      iconBefore: /* @__PURE__ */ React.createElement(SocialLinkedinColouredIcon, null),
      a11yLabel: (_a = props.a11yLabel) != null ? _a : defaultLabel
    },
    children != null ? children : defaultLabel
  );
});
export {
  SocialLinkedInButton
};
